import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import Navigation from "./components/Navigation/Navigation";

export default function App() {
  return (
    <>
      <Router>
        <Navigation />
        <Routes>
          <Route path="*" element={<AppRoutes />} />
        </Routes>
      </Router>
    </>
  );
}
